export default __webpack_public_path__ + "static/media/levelup.4bb4702a.gif";